import jQuery from 'jquery';
import 'jquery.scrollbar';
import 'featherlight';
import 'jcarousellite/jcarousellite.min';
import '../../lib/jquery.tooltipster.min';
import '../../scripts/utilities/custom_select';
import '../../scripts/utilities/eq_height';
import '../../scripts/utilities/isElementInside';
import '../../scripts/utilities/foldable_text';
import '../../scripts/utilities/toggle';
import '../../scripts/_global/initGoogleMapDependencies';
import '../../scripts/_global/flux_stores';
import Carousel from './../../scripts/utilities/carousel';

// these need to be globally available for several third party scripts
const window = require('window');
window['jQuery'] = window['$'] = jQuery;
window['Carousel'] = Carousel;
window['jQuery'] = window['$'] = jQuery;
